import { createFileRoute } from '@tanstack/react-router';
import SupplierLayout from '@components/layout/supplier/SupplierLayout.tsx';

export const Route = createFileRoute('/s/$orgId/$portalId/my-account')({
  component: RouteComponent,
});

function RouteComponent() {
  return <SupplierLayout>Muj ucet</SupplierLayout>;
}
